import { Resolver, Element, SerializedNodes } from '@craftjs/core';
import { ElementType, FunctionComponent, ReactNode, SVGProps } from 'react';
import {
  BaseScoreSection,
  BaseVariableSection,
  IBaseScoreSection,
  IBaseVariableSection,
} from 'src/services/api/api-client';
import { LayoutAttachmentType } from '../context/attachments.context';

export type GeneralFormBuilderProps = {
  defaultLayout: SerializedNodes;
  resolver: Resolver;
  selectors: SelectorResolverType<Resolver>;
  layerItem: ElementType<any>;
  onSave: (params: SaveFormParams) => Promise<void>;
  onSaveAs?: (params: SaveFormParams) => Promise<void>;
  onDelete?: () => Promise<void>;
  loading: boolean;
  initialScoreSections: BaseScoreSection[];
  initialVariables: BaseVariableSection[];
  formConfigSettingPanel: JSX.Element;
  uploadFileFunction: (localFile: LayoutAttachmentType) => Promise<string>;
  configSelectorComponent?: JSX.Element;
};

export enum SelectorGroupEnum {
  None,
  Containers,
  Content,
  ConstFields,
  InputFields,
  Time,
  SingleChoice,
  MultipleChoice,
  OtherInput,
}

export type SelectorType = {
  Icon: FunctionComponent<SVGProps<any>>;
  name: string;
  group: SelectorGroupEnum;
  userComponent: Element<React.ElementType>;
};

export type SelectorResolverType<T extends Resolver> = {
  [K in keyof T]: SelectorType;
};

export type SaveFormParams = {
  nodes: SerializedNodes;
  scoreSections: IBaseScoreSection[] | undefined;
  variables: IBaseVariableSection[] | undefined;
};
